import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class GetSupplyTrend extends Http {
  [x: string]: any
  public async getSupplyTrend(data: NLoginApi.SupplyTrendRequestData) {
    return await super.request<NLoginApi.SupplyTrendResponse>({
      url: '/crossbowSystem/supplyTrend',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getSupplyMonthlyTrend(data: NLoginApi.SupplyTrendRequestData) {
    return await super.request<NLoginApi.SupplyTrendResponse>({
      url: '/crossbowSystem/supplyMonthlyTrend',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getBankNames(data: NLoginApi.MultiBankRequestData) {
    return await super.request<NLoginApi.MultiBankResponse>({
      url: '/crossbowSystem/getBankNames',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async getBankLevels(data: NLoginApi.BankLevelsRequestData) {
    return await super.request<NLoginApi.BankLevelsResponse>({
      url: '/crossbowSystem/getBankLevels',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async getTime(data: NLoginApi.getTimeRequestData) {
    return await super.request<NLoginApi.getTimeResponse>({
      url: '/crossbowSystem/supplyTrendDate',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getBankLevel1s(data: NLoginApi.BankLevel1sRequestData) {
    return await super.request<NLoginApi.BankLevel1sResponse>({
      url: '/crossbowSystem/getBankLevel1s',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getBankLevel2s(data: NLoginApi.BankLevel2sRequestData) {
    return await super.request<NLoginApi.BankLevel2sResponse>({
      url: '/crossbowSystem/getBankLevel2s',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getDialogTag(data: NLoginApi.DialogTagRequestData) {
    return await super.request<NLoginApi.DialogTagResponse>({
      url: '/crossbowSystem/getDialogTag',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default GetSupplyTrend
